import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import VerticalSplitRoundedIcon from '@mui/icons-material/VerticalSplitRounded'
import CallToActionRoundedIcon from '@mui/icons-material/CallToActionRounded'
import { AppTabs } from 'src/component/common/analog/molecule/tab/AppTabs'
import { TeamDashboardInsights } from '../component/templates/TeamDashboardInsights'
import { TeamComparisonView } from '../component/templates/TeamComparisonView'
import { RoleComparisonView } from '../component/templates/RoleComparisonView'
import { UserComparisonView } from '../component/templates/UserComparisonView'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'

export type TeamViewType = 'all' | 'team' | 'role' | 'user'

export const MyTeamDashboard = observer(() => {
  const { translation } = useLocalizationStore()
  const tabs = translation.pages.myTeam.tabs

  const teamViewTabs = [
    { label: tabs.all(), value: 'all' as TeamViewType },
    { label: tabs.teamVsTeam(), value: 'team' as TeamViewType },
    { label: tabs.roleVsRole(), value: 'role' as TeamViewType },
    { label: tabs.userVsUser(), value: 'user' as TeamViewType },
  ]
  const [viewType, setViewType] = useState<TeamViewType>('all')
  const [showFilters, setShowFilters] = useState(true)

  const isComparisonView = viewType !== 'all'

  return (
    <Box sx={styles.root}>
      <Box sx={styles.headerRow}>
        <AppTabs value={viewType} onChange={setViewType} tabs={teamViewTabs} />
        {isComparisonView && (
          <Tooltip title={showFilters ? tabs.hideFilters() : tabs.showFilters()}>
            <IconButton
              onClick={() => setShowFilters(!showFilters)}
              size="small"
              sx={styles.layoutToggleButton}
            >
              {showFilters ? <VerticalSplitRoundedIcon /> : <CallToActionRoundedIcon />}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {viewType === 'all' && <TeamDashboardInsights />}
      {viewType === 'team' && <TeamComparisonView isSidebarCollapsed={!showFilters} />}
      {viewType === 'role' && <RoleComparisonView isSidebarCollapsed={!showFilters} />}
      {viewType === 'user' && <UserComparisonView isSidebarCollapsed={!showFilters} />}
    </Box>
  )
})

const styles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    padding: 20,
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 15,
  },
  layoutToggleButton: {
    backgroundColor: 'background.paper',
    color: 'text.primary',
    border: '1px solid',
    borderColor: 'divider',
    '&:hover': {
      backgroundColor: 'action.hover',
      borderColor: 'divider',
    },
  },
} as const
